import React, { createContext } from "react";
import { type PillarModalControl } from "shared/components/pillar-modal/usePillarModalControl";
import { type InvoiceItemView } from "shared/mappers/database/accounting/invoice/invoice-item";

type HubCheckoutInvoiceItemContextType = {
  index: number;
  invoiceItem: InvoiceItemView;
  openDiscountCodeModal: (invoiceItem: InvoiceItemView) => void;
  discountCodeModalControl: PillarModalControl;
  selectedInvoiceItem: InvoiceItemView | null;
  setSelectedInvoiceItem: React.Dispatch<
    React.SetStateAction<InvoiceItemView | null>
  >;
  deleteInvoiceItemModalOpen: boolean;
  setDeleteInvoiceItemModalOpen: (item: InvoiceItemView | null) => void;
};
export const HubCheckoutInvoiceItemContext = createContext<
  HubCheckoutInvoiceItemContextType | undefined
>(undefined);

export const useHubCheckoutInvoiceItemContext = () => {
  const context = React.useContext(HubCheckoutInvoiceItemContext);
  if (!context) {
    throw new Error(
      "useHubCheckoutInvoiceItemContext must be used within a HubCheckoutInvoiceItemContextProvider",
    );
  }
  return context;
};
